// components/room-next.js: ROUND-3 AUDIT A8 "Next:" line text model.
//
// The room page tells the viewer what happens next in three cases:
//   • guest → waiting for the host to start,
//   • host with fewer than 4 players and bot fill off → invite more
//     players or turn on bot fill,
//   • host ready to start (4 humans, or bot fill on) → press Start Game.
//
// Pure .js (no JSX) so Node tests can import it directly. The shortage
// math mirrors start-game-logic.js (TOTAL_SEATS = 4).

export const ROOM_TOTAL_SEATS = 4;

/**
 * @param {{
 *   isHost: boolean,
 *   occupantCount: number,
 *   botFill: boolean,
 *   hostName?: string|null,
 * }} ctx
 * @returns {string} the full "Next: ..." line.
 */
export function roomNextText({ isHost, occupantCount, botFill, hostName }) {
  if (!isHost) {
    const host = (hostName || '').trim() || 'the host';
    return `Next: waiting for ${host} to start the game.`;
  }
  if (occupantCount < ROOM_TOTAL_SEATS && !botFill) {
    const need = ROOM_TOTAL_SEATS - occupantCount;
    const players = need === 1 ? '1 more player' : `${need} more players`;
    return `Next: invite ${players}, or turn on bot fill, then press Start Game.`;
  }
  return 'Next: press Start Game when everyone is ready.';
}
